/** Mode l'environnement selon Node
 * 'development' => Développement local
 * 'production' => Version déployée
 */
export const developmentMode = process.env.NODE_ENV === 'development'

/** Comportement de l'environnement
 * 'test' => Environnement de test (local, staging, integ, release, etc)
 * 'production' => Environnement de production (prod)
 */
export const envBehavior = process.env.REACT_APP_ENV_BEHAVIOR
